import BinaryStateButton from "components/BinaryStateButton";
import { IconCollection } from "components/Icon/IconCollection";
import Tooltip from "components/Tooltip/Tooltip";
import { setPinned } from "containers/QuickAccess/QuickAccess.service";
import { getRecordUserData } from "containers/Resources/Resources.selectors";
import { isEmpty } from "lodash";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export const PinPopover = ({
    resourceData,
    style,
}: {
    resourceData: any;
    style?: React.CSSProperties;
}) => {
    const dispatch = useDispatch();
    const recordUserSelector = useCallback(
        (state) => {
            const projectOrBundleId = resourceData?.project_id ?? resourceData?.bundle_id;
            const recordId = resourceData?.id;

            return getRecordUserData(state, recordId, projectOrBundleId);
        },
        [resourceData?.bundle_id, resourceData?.id, resourceData?.project_id]
    );
    const recordUser = useSelector(recordUserSelector);
    const isPinned = recordUser.isPinned ?? false;

    // The pin/unpin mutation targets the record's RECORD_USER entry
    // (`recordUser.id`), which is resolved from the parent container's
    // opened/pinned lists — a separate data source from `resourceData`. During
    // the initial load race it can still be undefined even once `resourceData`
    // is present. Gate the action on it so a mid-load click never fires the
    // mutation with `id: undefined` ("required field 'id' was not provided").
    const isReady =
        !isEmpty(resourceData) && resourceData?.deleted_at == null && recordUser.id != null;

    return (
        <Tooltip overlay={isPinned ? "Unpin from sidebar" : "Pin to sidebar"} overlayStyle={style}>
            <BinaryStateButton
                trueStateIcon={IconCollection.pinOffOutline}
                falseStateIcon={IconCollection.pinOutline}
                state={isPinned}
                onClick={() => {
                    if (!isReady) return;
                    setPinned(dispatch, recordUser.id, !isPinned);
                }}
                className="pinButton"
                disabled={!isReady}
            />
        </Tooltip>
    );
};
